module.exports = __webpack_public_path__ + "waves.d87b492bfbf4124ea857.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/waves.svg
// module id = ../../../../../src/assets/images/waves.svg
// module chunks = main